import { render, staticRenderFns } from "./SelectDatabase.vue?vue&type=template&id=d5b1121a&scoped=true"
import script from "./SelectDatabase.vue?vue&type=script&lang=js"
export * from "./SelectDatabase.vue?vue&type=script&lang=js"
import style0 from "./SelectDatabase.vue?vue&type=style&index=0&id=d5b1121a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b1121a",
  null
  
)

export default component.exports